import { isFreemiumBillingState } from "../services/helpers";

const SMALL_COMPANY_SIZE_PATTERN = /^1\s*(?:-|to)\s*5(?:\s+people)?$/i;

const normalizeCompanySize = (value) => String(value || "").trim().toLowerCase();

export const getCompanySizeValue = (userProfile) => {
  if (!userProfile) return "";

  if (userProfile.role === "companyUser") {
    return userProfile.peoples || "";
  }

  return userProfile.companyData?.peoples || userProfile.peoples || "";
};

export const isSmallCompanyByEmployeeCount = (peoples) => {
  const normalized = normalizeCompanySize(peoples);
  if (!normalized) return false;
  return (
    normalized === "1 to 5 people" ||
    normalized === "1 - 5 people" ||
    SMALL_COMPANY_SIZE_PATTERN.test(normalized)
  );
};

export const isLargeCompanyByEmployeeCount = (peoples) => {
  const normalized = String(peoples || "").trim();
  if (!normalized) return false;
  return !isSmallCompanyByEmployeeCount(normalized);
};

export const isCompanySizeReady = (userProfile, { loading = false, hasUserData = false } = {}) => {
  if (loading) return false;
  if (Boolean(String(getCompanySizeValue(userProfile) || "").trim())) {
    return true;
  }
  return hasUserData;
};

const isFreemiumPlan = (userProfile = {}) =>
  isFreemiumBillingState(userProfile) ||
  String(userProfile?.subscriptionDetails?.plan?.name || "").toLowerCase() === "freemium";

export const shouldShowOnboardingCallOption = (userProfile) =>
  isLargeCompanyByEmployeeCount(getCompanySizeValue(userProfile)) &&
  !isFreemiumPlan(userProfile);
